import type { IconNode } from '../types';

/**
 * @name id-card-lanyard
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuNSA4aC0zIiAvPgogIDxwYXRoIGQ9Im0xNSAyLTEgMmgzYTIgMiAwIDAxMiAydjE0YTIgMiAwIDAxLTIgMkg3YTIgMiAwIDAxLTItMlY2YTIgMiAwIDAxMi0yaDMiIC8+CiAgPHBhdGggZD0iTTE2IDIyYTQgNCAwIDAwLTggMCIgLz4KICA8cGF0aCBkPSJtOSAyIDMgNiIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjE1IiByPSIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/id-card-lanyard
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const IdCardLanyard: IconNode = [
  ['path', { d: 'M13.5 8h-3' }],
  ['path', { d: 'm15 2-1 2h3a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h3' }],
  ['path', { d: 'M16 22a4 4 0 00-8 0' }],
  ['path', { d: 'm9 2 3 6' }],
  ['circle', { cx: '12', cy: '15', r: '3' }],
];

export default IdCardLanyard;
